import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import faSearch from '@fortawesome/fontawesome-free-solid/faSearch';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import './MainNavigation.css';
import NavIcon from './NavIcon';
import Button from './common/Button';
import collectMeLogo from '../images/collectme-logo.svg';

import TextInput from './common/form/TextInput';

// Helper to determine if the "My Collections" link should be showing as active
function isCollectionsActive(match, location) {
  if (!match) {
    return false;
  }

  if (location.pathname === '/' || location.pathname.indexOf('/collections/') === 0) {
    return true;
  }

  return false;
}
function getSearchBar(history) {
  return (
    <Formik
      onSubmit={(values) => {
        const value = !values.searchTerm ? '' : values.searchTerm;
        history.push(`/collections/search/${value}`);
      }}
      render={({ handleSubmit }) => (
        <Form>
          <div className="mainNav-search field is-grouped">
            <Field
              name="searchTerm"
              placeholder=""
              type="serchTerm"
              required
              autoComplete=""
              component={TextInput}
            />
            <Button
              type="submit"
              label={<FontAwesomeIcon icon={faSearch} className="icon" fixedWidth fixedHeight />}
              handler={handleSubmit}
            />
          </div>
        </Form>
      )}
    />
  );
}

function getNavEntries() {
  return (
    <ul className="mainNav">
      <li className="mainNav-entry">
        <NavLink
          className="mainNav-link"
          activeClassName="mainNav-link--active"
          to="/"
          isActive={isCollectionsActive}
        >
          <NavIcon type="collection" />
          My Collection
        </NavLink>
      </li>
      <li className="mainNav-entry">
        <NavLink className="mainNav-link" activeClassName="mainNav-link--active" to="/dashboard">
          <NavIcon type="dashboard" />
          Dashboard
        </NavLink>
      </li>
      <li className="mainNav-entry">
        <NavLink className="mainNav-link" activeClassName="mainNav-link--active" to="/financials">
          <NavIcon type="financials" />
          Financials
        </NavLink>
      </li>
      <li className="mainNav-entry">
        <NavLink className="mainNav-link" activeClassName="mainNav-link--active" to="/contacts">
          <NavIcon type="contacts" />
          Contacts
        </NavLink>
      </li>
    </ul>
  );
}

function getList(history) {
  const searchBarFirst = window.innerWidth >= 500;

  if (searchBarFirst) {
    return (
      <div className="flex-column justify-center">
        {getSearchBar(history)}
        {getNavEntries()}
      </div>
    );
  }
  return (
    <div className="flex-column justify-center">
      {getNavEntries()}
      {getSearchBar(history)}
    </div>
  );
}

class MainNavigation extends React.PureComponent {
  render() {
    const { history } = this.props;
    return (
      <nav className="app-nav">
        <div className="appNav-logo">
          <img src={collectMeLogo} alt="CollectMe" />
        </div>
        {getList(history)}
      </nav>
    );
  }
}

MainNavigation.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};
export default withRouter(MainNavigation);



// WEBPACK FOOTER //
// ./src/components/MainNavigation.jsx